module.exports = __webpack_public_path__ + "img/40.fbf3396d.jpg";